import React, { PureComponent } from 'react';
import ProductFocusedLAStackCard from 'appSrc/components/List-Article/Cards/ProductFocusedLAStackCard';
import PropTypes from 'prop-types';
import { VariableLink } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class ProductFocusedCardStack extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.productFocusedCardStack } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        { carousel.title &&
                            <div className={ 'carousel-title-bar ' + style.carouselTitleBar }>
                                <h2>{ carousel.title }</h2>
                                { carousel.link_url &&
                                    <VariableLink to={ carousel.link_url }>{ carousel.link_text || 'See All' }</VariableLink>
                                }
                            </div>
                        }
                        <div className={ style.set }>
                            { content.map( ( card, i ) => ( <ProductFocusedLAStackCard key={ i } item={ card } /> ) ) }
                        </div>
                    </div>
                }
            </div>
        );
    }
}
ProductFocusedCardStack.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
ProductFocusedCardStack.defaultProps = {
    className: '',
    carousel: {},
};

export default ProductFocusedCardStack;
